namespace HA.Core.HTML.TBox {
    export class SimpleItemList extends Div {

        protected createItem(data: string) {
            return new SimpleListItem(data);
        }

        protected createSelf() {
            super.createSelf();
            this.addClass("sl");
            const me = this;
            const tdata = this.get("d");
            tdata.forEach((item: any) => {
                me.appendChild(this.createItem(item));
            });
        }
    }
}
